import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Auth is cookie-based (httpOnly `access_token`/`session_token`).
// `withCredentials` sends the cookie on every request; no token is read from JS storage.
export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
